// extracted by mini-css-extract-plugin
export default {"formBlock":"YAo9je"};